import { Component, OnInit } from '@angular/core';
import { LegalNoticeMessages } from 'src/app/modules/shared/models/component-messages/legal-notice-message';

@Component({
  selector: 'app-legal-notice',
  templateUrl: './legal-notice.component.html',
  styleUrls: ['./legal-notice.component.scss']
})
export class LegalNoticeComponent implements OnInit {

  public legalNoticeMessages = new LegalNoticeMessages();

  constructor() {
  }

  public ngOnInit() {
  }

}
